import { useMutation } from "@tanstack/react-query";
import { termDetailApi } from "components/api/comm";
import TermView from "components/view/term";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { successControl } from "util/commAction";

export default function TermsPage() {
  const { prvCd } = useParams();

  const [termInf, setTermInf] = useState();

  const termDetail = useMutation({
    mutationFn: termDetailApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            //성공시
            setTermInf(res.data.prvDtl);
          },
        });
      }
    },
  });

  useEffect(() => {
    if (prvCd) {
      termDetail.mutate(prvCd);
    }
  }, [prvCd]);
  return (
    <>
      <TermView termInf={termInf} />
    </>
  );
}
